<template>
  <router-link 
    v-if="type !== 'bic'"
    :class="linkClass" 
    v-bind:data-ref-id="bicref.id" 
    data-gtm-category="Cross Reference"
    v-bind:data-gtm-action="bicref.type" 
    v-bind:data-gtm-label="bicref.desc"
    v-bind:to="linkTo"
  >
    {{ bicref.desc }}
  </router-link>
  
  <a
    v-else
    :class="linkClass" 
    v-bind:data-ref-id="bicref.id" 
    data-gtm-category="Cross Reference"
    v-bind:data-gtm-action="bicref.type" 
    v-bind:data-gtm-label="bicref.desc"
    v-on:click.prevent="() => click({ id: bicref.id })"
  >
   {{ bicref.desc }}
  </a>
</template>

<script>
  import Vue from 'vue';
  
  export default Vue.component('BicItemRefLink', {
    props: {
      bicref: Object,
      click: Function,
    },
    computed: {
      type: function() {
        return this.bicref.type.toLowerCase();
      },
      linkClass: function() {
         return `ref-link-${this.type}`;
      },
      linkTo: function() {
         return `/browse/${this.type}/${this.bicref.id}`;
      },
    },
  });
</script>